import styled from 'styled-components';

export const PlayerContainer = styled.div`
    overflow: hidden;
    position: absolute;
    width: 100%;
    height: 100%;
`;

export const Player = styled.div<{
    videoWidth: number;
    videoHeight: number;
}>`
    position: absolute;
    height: 100%;
    ${({ videoWidth, videoHeight }) =>
        `width: ${(videoWidth / videoHeight) * 100}vh`};
    min-width: 100%;
    ${({ videoWidth, videoHeight }) =>
        `min-height: ${(videoHeight / videoWidth) * 100}vw`};
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
`;
